module.exports = __webpack_public_path__ + "static/media/google_play_badge.d6ec3259.png";